export default {
  setSearchValue(state, searchValue) {
    state.searchValue = searchValue
  },
  setInstantSearchOpened(state, opened) {
    state.opened = opened
  }
}
